<template>
  <div class="wrapper">
    <div class="left">
      <div class="header">
        <div class="back">
          <el-button type="text"
                     @click="back">
            <i class="el-icon-arrow-left"></i>
          </el-button>
        </div>
        <div class="title">
          <span class="name">{{plan.Name}} - {{(jobsiteName)}}</span>
          <el-link icon='el-icon-edit'
                   @click="openRenameDialog"
                   style="font-size:20px;margin:0 15px 0 8px"
                   :title="$t('diagrams.Rename')"
                   :underline="false"></el-link>
        </div>
        <div class="option-line">
          <el-dropdown class="add-task"
                       v-has="'Add Task'"
                       @command="toAddDragMarker">
            <el-button type="defult"
                       size="mini"
                       style="font-size:14px;color:#3b84dd;border-color:#3b84dd;margin-right:20px;">
              {{$t('model.AddTask')}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="Task">{{$t('model.Task')}}</el-dropdown-item>
              <el-dropdown-item command="Product">{{$t('model.ProductInstallation')}}</el-dropdown-item>
              <el-dropdown-item command="Moisture">{{$t('model.Moisture')}}</el-dropdown-item>
              <el-dropdown-item v-if="taskTemplates.length > 0"
                                command="TaskTemplate">{{$t('model.TaskTemplate')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip class="item"
                      effect="dark"
                      :content="$t('model.ZoomIn')"
                      placement="bottom">
            <el-button type="text"
                       @click="zoom(1)">
              <i class="el-icon-zoom-in"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="dark"
                      :content="$t('model.ZoomOut')"
                      placement="bottom">
            <el-button type="text"
                       @click="zoom(0)">
              <i class="el-icon-zoom-out"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item"
                      effect="dark"
                      :content="$t('model.ZoomAll')"
                      placement="bottom">
            <el-button type="text"
                       @click="fitPage">
              <svg-icon iconClass="zoom"></svg-icon>
            </el-button>
          </el-tooltip>
          <el-dropdown @command="handleReportCommand"
                       v-has="'Create Report'"
                       :disabled="this.list.length<1">
            <el-button size="mini"
                       type="text"
                       :title="$t('task.NewReport')">
              <svg-icon iconClass="report_add"></svg-icon>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled
                                style="line-height:20px;font-size:12px">Select Report Type</el-dropdown-item>
              <el-dropdown-item :command="composeReportCommand(5)"
                                :disabled="this.list.length < 1"
                                divided>{{$t('model.Task')}}</el-dropdown-item>
              <el-dropdown-item :command="composeReportCommand(1)"
                                :disabled="this.list.length < 1">{{$t('model.ProductInstallation')}}</el-dropdown-item>
              <el-dropdown-item :command="composeReportCommand(4)"
                                :disabled="this.list.length < 1">{{$t('model.Moisture')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-badge is-dot
                    class="item"
                    :hidden='this.hasCondition'>
            <el-popover placement="bottom-end"
                        width="300"
                        trigger="click">
              <el-button slot="reference"
                         type="text"
                         :title="$t('index.Filters')">
                <svg-icon iconClass="filter"></svg-icon>
              </el-button>
              <el-button size="mini"
                         @click="clearFilter"
                         class="clear">{{$t('model.ClearFilter')}}</el-button>
              <el-form class="filter"
                       size="mini"
                       label-position="top">
                <el-form-item :label="$t('model.Type')">
                  <el-select :placeholder="$t('model.Type')"
                             size="mini"
                             @change="search()"
                             v-model="condition.Type"
                             clearable>
                    <el-option v-for=" i of taskType"
                               :key="i.Key"
                               :label="$t('model.'+i.Value)"
                               :value="i.Key"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.Status')">
                  <el-select :placeholder="$t('model.Status')"
                             size="mini"
                             @change="search()"
                             v-model="condition.Status"
                             clearable>
                    <el-option v-for=" i of taskStatus"
                               :key="i.Value"
                               :label="i.Key"
                               :value="i.Value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.TaskGroup')">
                  <el-select size="mini"
                             @change="search()"
                             v-model="condition.GroupId"
                             clearable>
                    <el-option v-for="i of taskGroup"
                               :key="i.PhaseId"
                               :label="i.Name"
                               :value="i.PhaseId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.DueDate')">
                  <el-row>
                    <el-col :span="11">
                      <el-form-item prop="DueStartTime">
                        <el-date-picker type="date"
                                        :placeholder="$t('model.From')"
                                        @change="search()"
                                        v-model="condition.DueStartTime"
                                        size="mini"
                                        style="width: 100%;"></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col style="text-align:center"
                            :span="2">-</el-col>
                    <el-col :span="11">
                      <el-form-item prop="DueEndTime">
                        <el-date-picker type="date"
                                        :placeholder="$t('model.To')"
                                        @change="search()"
                                        v-model="condition.DueEndTime"
                                        size="mini"
                                        style="width: 100%;"></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item :label="$t('model.Assignee')">
                  <el-select :placeholder="$t('model.Assignee')"
                             clearable
                             @change="search()"
                             v-model="condition.AssignedUserIds"
                             size="mini">
                    <el-option v-for="item in projectUser"
                               :key="item.UserId"
                               :label="item.FullName"
                               :value="item.UserId">
                      <div class="user-logo">
                        <img :src="item.AvatarUrl"
                             alt="">
                      </div>
                      <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('model.Watching')">
                  <el-select :placeholder="$t('model.Watching')"
                             clearable
                             @change="search()"
                             v-model="condition.WatchingUserIds"
                             size="mini">
                    <el-option v-for="item in projectUser"
                               :key="item.UserId"
                               :label="item.FullName"
                               :value="item.UserId">
                      <div class="user-logo">
                        <img :src="item.AvatarUrl"
                             alt="">
                      </div>
                      <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-popover>
          </el-badge>
        </div>
      </div>
      <div class="main">
        <div class="diag">
          <div class="container">
            <pdftron ref="pdftron"
                     :pdfFile="pdfFile"
                     :xfdfStrings="xfdfStrings"
                     @loaded="handleLoaded"
                     @pageComplete="handlePageComplete"></pdftron>
            <div class="toolBar">
              <div class="toolBar-container">
                <div class="toolBarItem"
                     :class="{toolDivActive:toolShows==0}">
                  <el-tooltip content="Pan"
                              placement="right">
                    <button class="toolButton"
                            @click="pan">
                      <div class="Icon">
                        <svg viewBox="0 0 20 20"
                             version="1.1"
                             xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
                          <title>icon-header-pan20</title>
                          <g stroke="none"
                             stroke-width="1"
                             fill="none"
                             fill-rule="evenodd">
                            <g transform="translate(-369.000000, -78.000000)">
                              <g transform="translate(-22.000000, 0.000000)">
                                <g transform="translate(391.000000, 78.000000)">
                                  <rect style="fill: none;"
                                        x="0"
                                        y="0"
                                        width="20"
                                        height="20"></rect>
                                  <path style="fill: currentColor;"
                                        d="M4.84116789,10.6404137 C4.46186271,10.6404137 3.96297997,10.9126703 3.804829,11.1798615 C3.56953121,11.5774827 3.81897258,11.930783 3.98998135,12.1055337 L4.90417112,13.043869 C5.82350401,13.9872696 6.74283689,14.9294038 7.66345556,15.8690054 C9.43397498,17.6696974 11.5349399,18.024264 13.7413389,16.8921834 C15.5478601,15.9639786 16.5301962,14.4798639 16.66006,12.4816276 C16.7089197,11.7281735 16.7024908,10.9506595 16.6947761,10.1984717 L16.689633,9.37283798 C16.689633,9.37283798 16.6909188,7.17705742 16.6857756,6.07663452 C16.6844899,5.86516085 16.6214866,5.70560586 16.4993375,5.60176848 C16.3797599,5.49919742 16.1971792,5.44474611 15.9721676,5.44474611 L15.9631671,5.44474611 C15.5607179,5.44601242 15.1454109,5.73346466 15.1454109,6.20959701 L15.1441251,9.50833309 C15.1441251,9.63876296 15.1454109,9.78945378 15.0618352,9.92494889 C14.8496814,10.2630535 14.5938112,10.4302064 14.2955101,10.4302064 C13.8622022,10.4302064 13.5960457,10.0515798 13.5021837,9.88949223 C13.4288942,9.77045914 13.43018,9.63496403 13.4314658,9.54505606 L13.4314658,8.23949103 C13.4327516,6.96431743 13.4327516,5.68661122 13.4288942,4.41017131 C13.4327516,4.10372442 13.1254501,3.7656198 12.6239958,3.74789147 C12.3899838,3.75675564 12.2151177,3.84666361 12.1199699,3.9391042 C11.9605332,4.09359395 11.8923868,4.29493715 11.8949584,4.42663333 C11.9232456,5.8993512 11.9219598,7.41765621 11.9193882,8.90050456 L11.9193882,9.48427321 C11.9193882,9.61090415 11.9103878,9.74260033 11.8460987,9.86923128 C11.7830955,9.9933296 11.5426546,10.3985486 11.0939173,10.3985486 C10.6541804,10.3985486 10.3725946,10.0249873 10.3083056,9.89329116 C10.2337303,9.7375351 10.2337303,9.5767138 10.2337303,9.44881654 L10.2337303,7.43031931 C10.2337303,6.08423238 10.2337303,4.74067807 10.229873,3.39585745 C10.2388734,3.22743829 10.1758702,3.06914962 10.0562926,2.94378498 C9.89557009,2.77663214 9.65770074,2.68419155 9.38768689,2.68419155 C8.82708669,2.68419155 8.52621411,3.11726937 8.52492833,3.4300478 C8.52364255,4.64950379 8.52492833,5.78791597 8.52621411,6.94025756 L8.52878567,9.50200154 L8.52492833,10.8506211 C8.72551005,11.0063771 9.30539695,11.4470528 9.70913195,11.754766 C10.0640073,12.0257562 10.381595,12.2650887 10.487029,12.3511978 C10.6593236,12.4904918 10.6914681,12.8159333 10.6708956,12.9995482 C10.6400369,13.2756037 10.4960295,13.4896099 10.2671606,13.6048441 C10.0112903,13.7327414 9.60755531,13.7276761 9.41725983,13.5947136 C9.09452899,13.362979 8.38092094,12.8627868 7.84475058,12.4866929 C7.4783032,12.2296321 7.19414576,12.0308215 7.1658586,12.0080279 C6.73897955,11.7142441 5.72449892,11.0127087 5.56377639,10.9000072 C5.36319467,10.7936372 5.18832856,10.7163923 5.02117712,10.6657399 C4.96588857,10.6480116 4.9054569,10.6404137 4.84116789,10.6404137 M11.253354,19.2323232 C9.51112179,19.2323232 7.84475058,18.4750702 6.43424963,17.0403416 C5.66792459,16.2577624 4.90288534,15.4726505 4.13784608,14.688805 L2.75691808,13.2705384 C1.9353045,12.429709 1.76686728,11.2748347 2.32875326,10.3301679 C2.87392409,9.41335988 4.28442503,8.68396565 5.52134564,9.05499431 C5.80678886,9.14110335 6.09223208,9.26520168 6.42139183,9.44501762 L6.81869793,9.71220891 L6.81612637,3.42751519 C6.81741215,2.25997789 7.80103405,1 9.38768689,1 C10.1334394,1 10.8136172,1.27858808 11.2996421,1.78764447 C11.4359348,1.92820482 11.5542266,2.0877598 11.6493744,2.25617896 C11.9631048,2.12321647 12.3051223,2.05230314 12.6805701,2.06496623 C13.851916,2.10802075 14.8355379,2.89946415 15.0798361,3.9125117 C15.3575646,3.81373956 15.6532941,3.76308719 15.9554525,3.76182088 C16.6729178,3.76182088 17.2798061,3.99228919 17.7259719,4.42663333 C18.1605656,4.8521133 18.3920061,5.41941993 18.3945776,6.06903666 C18.4010065,7.17199218 18.398435,9.37410429 18.398435,9.37410429 L18.4035781,10.1883413 C18.4112928,10.9671216 18.4190074,11.7724944 18.3662905,12.5879976 C18.2004248,15.1776004 16.8734996,17.1821683 14.5320937,18.3851622 C13.4353231,18.9486699 12.3321237,19.2323232 11.253354,19.2323232"></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
                <div class="toolBarItem"
                     :class="{toolDivActive:toolShows==6}">
                  <el-tooltip content="Cloud"
                              placement="right">
                    <button class="toolButton"
                            @click="cloudy">
                      <div class="toolDiv">
                        <i class="toolI"
                           style="filter: drop-shadow(#D3D3D3 22px 0px);">
                          <img src="../../../assets/image/cloud.png">
                        </i>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
                <div class="toolBarItem"
                     :class="{toolDivActive:toolShows==1}">
                  <el-tooltip content="Arrow"
                              placement="right">
                    <button class="toolButton"
                            @click="arrow">
                      <div class="toolDiv">
                        <i class="toolI">
                          <img style="height: 17px;"
                               src="../../../assets/image/arrow.png">
                        </i>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
                <div class="toolBarItem"
                     :class="{toolDivActive:toolShows==2}"
                     v-show="1==2">
                  <el-tooltip content="Distance"
                              placement="right">
                    <button class="toolButton"
                            @click="measure">
                      <div class="Icon "
                           style=""><svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 24 24">
                          <title>icon-tool-measurement-distance-line</title>
                          <path style="fill: #abb0c4;"
                                d="M21.46,6.59l-4.05-4a2,2,0,0,0-2.79.08l-12,12a2,2,0,0,0-.08,2.79l4.05,4.05a2,2,0,0,0,2.79-.08l12-12A2,2,0,0,0,21.46,6.59ZM20,8,8,20a.43.43,0,0,1-.09.06s0,0,0,0l-4-4A.17.17,0,0,1,4,16L5.24,14.7l2,2,1.35-1.35-2-2L7.94,12l2.71,2.7L12,13.35l-2.7-2.7L10.65,9.3l2,2L14,10l-2-2,1.35-1.35L16.06,9.3l1.35-1.36L14.7,5.24,16,4c.06-.05.1-.06.09-.08l4,4A.17.17,0,0,1,20,8Z"></path>
                        </svg></div>
                    </button>
                  </el-tooltip>
                </div>
                <div class="toolBarItem"
                     :class="{toolDivActive:toolShows==3}">
                  <el-tooltip content="Free Hand highlight"
                              placement="right">
                    <button class="toolButton"
                            @click="highlight">
                      <div class="toolDiv">
                        <i class="toolI">
                          <img style="height: 20px;"
                               src="../../../assets/image/highlight.png">
                        </i>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
                <div class="toolBarItem"
                     :class="{toolDivActive:toolShows==4}">
                  <el-tooltip content="Free Text"
                              placement="right">
                    <button class="toolButton"
                            @click="freetext">
                      <div class="toolDiv">
                        <i class="toolI">
                          <img style="height: 19px;"
                               src="../../../assets/image/freetext.png">
                        </i>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
                <div class="toolBarItem"
                     :class="{toolDivActive:toolShows==5}">
                  <el-tooltip content="Free Hand"
                              placement="right">
                    <button class="toolButton"
                            @click="ink">
                      <div class="toolDiv">
                        <i class="toolI">
                          <img style="height: 19px;"
                               src="../../../assets/image/ink.png">
                        </i>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
                <div class="toolBarItem"
                     :class="{toolDivActive:toolShows==8}">
                  <el-tooltip content="Line"
                              placement="right">
                    <button class="toolButton"
                            @click="line">
                      <div class="Icon "
                           style=""><svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 24 24">
                          <title>icon - tool - shape - line</title>
                          <rect style="fill: #abb0c4;"
                                x="3"
                                y="10.75"
                                width="18"
                                height="2.5"
                                rx="0.6"
                                transform="translate(-4.97 12) rotate(-45)"></rect>
                        </svg></div>
                    </button>
                  </el-tooltip>
                </div>
                <div class="toolBarItem"
                     :class="{toolDivActive:toolShows==7}">
                  <el-tooltip content="Ellipse"
                              placement="right">
                    <button class="toolButton"
                            @click="ellipe">
                      <div class="toolDiv">
                        <i style="-webkit-filter: drop-shadow(#D3D3D3 32px 3px);
                                  filter: drop-shadow(#D3D3D3 32px 3px);
                                  left: -32px;"
                           class="toolI">
                          <img style="height: 16px;"
                               src="../../../assets/image/ellipe.png">
                        </i>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
                <div class="toolBarItem"
                     :class="{toolDivActive:toolShows==9}">
                  <el-tooltip content="Rectangle"
                              placement="right">
                    <button class="toolButton"
                            @click="rectangle">
                      <div class="toolDiv">
                        <i style="-webkit-filter: drop-shadow(#C0C0C0 31px 2px);
                                  filter: drop-shadow(#C0C0C0 31px 2px);
                                  left: -31px;"
                           class="toolI">
                          <img style="height: 18px;"
                               src="../../../assets/image/rectangle.png">
                        </i>
                      </div>
                    </button>
                  </el-tooltip>
                </div>
                <div style="margin-top: 4px;">
                  <el-color-picker v-model="toolColor"
                                   :predefine="predefineColors"
                                   @change="changeColor"></el-color-picker>
                </div>
                <div class="toolBarItem"
                     style="display:none">
                  <button class="toolButton"
                          style="color:#abb0c4;"
                          @click="setStrokeThickness">
                    {{this.getShowStrokeThickness()}}pt
                  </button>
                  <div style="position: absolute;
                                left: 60px;
                                background-color: #4c4c4c;
                                border-radius: 4px;
                                width: 130px;
                                bottom: 6px;"
                       v-show="isStrokeThickness">
                    <el-slider v-model="strokeThickness"
                               :min="strokeThicknessInfo.minSize"
                               :max="strokeThicknessInfo.maxSize"
                               @change="changeStrokeThickness"></el-slider>
                  </div>
                  <div style="position: absolute;
                                left: 60px;
                                background-color: #4c4c4c;
                                border-radius: 4px;
                                width: 180px;
                                bottom: 6px;"
                       v-show="isFontSize">
                    <el-slider v-model="fontInfo.fontSize"
                               :min="fontInfo.minSize"
                               :max="fontInfo.maxSize"
                               @change="changeStrokeThickness"></el-slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <el-menu :default-active="onRoute"
               v-if="$route.name !== 'modelTask2' && !bathEdit"
               class="el-menu"
               active-text-color="#4193f6"
               @select="select"
               :collapse-transition="false"
               mode="horizontal">
        <el-menu-item index="taskList2">
          <svg-icon iconClass="tasks"
                    class="menu-icon"></svg-icon>
          <span slot="title">{{$t('model.Tasks')}}</span>
        </el-menu-item>
      </el-menu>
      <div class="router-box">
        <router-view></router-view>
      </div>
    </div>
    <add-task-dialog :showDialog="addTaskDialogShow"
                     @closeDialog="closeAddTaskDialog"
                     :type="addTaskType"></add-task-dialog>
    <renameDialog :showDialog="renameDialog.showDialog"
                  :planId="this.plan.PlanId"
                  :planName="this.plan.Name"
                  :showTags="false"
                  @closeDialog="closeRenameDialog">
    </renameDialog>
    <reportConditionDialog :showDialog="newReportDialog.show"
                           :type="newReportDialog.type"
                           :taskIds="newReportDialog.taskIds"
                           :planId="newReportDialog.planId"
                           :isFromPdfPlan="newReportDialog.isFromPdfPlan"
                           @closeDialog="handleNewReportDialog">
    </reportConditionDialog>
  </div>
</template>

<script>
/* eslint-disable */
import { hasTasksByPlanId, getProductList, addMarkup, getMarkup, deleteTask } from '@/api/config'
import pdftron from '@/components/pdf/pdftron'
import { mapState } from 'vuex'
import { Notification } from 'element-ui'
import renameDialog from '@components/diagrams/renameDialog.vue'
import AddTaskDialog from './addTaskDialog'
import reportConditionDialog from '@/components/report/reportConditionDialog.vue'
import linearDanger from '@components/diagComponents/img/linear-danger.png'
import linearPrimary from '@components/diagComponents/img/linear-primary.png'
import linearSuccess from '@components/diagComponents/img/linear-success.png'
import moistureDanger from '@components/diagComponents/img/moisture-danger.png'
import moistureNormal_m from '@components/diagComponents/img/moisture-primary.png'
import moistureNormal_i from '@components/diagComponents/img/moisture-drop.png'
import moistureComplete from '@components/diagComponents/img/moisture-success.png'
import productDanger from '@components/diagComponents/img/product-danger.png'
import productComplete from '@components/diagComponents/img/product-success.png'
import productNormal_i from '@components/diagComponents/img/product-warning.png'
import taskDanger from '@components/diagComponents/img/task-danger.png'
import taskComplete from '@components/diagComponents/img/task-success.png'
import taskNormal from '@components/diagComponents/img/task-warning.png'
import taskNormalWall from '@components/diagComponents/img/wall-n.png'
import moistureNormalWall from '@components/diagComponents/img/wall-m-n.png'
import prodectNormalWall from '@components/diagComponents/img/wall-i-n.png'
import wallDanger from '@components/diagComponents/img/wall-danger.png'
import wallComplete from '@components/diagComponents/img/wall-success.png'
import taskSelect from '@components/diagComponents/img/task-select.png'
import replaced from '@components/diagComponents/img/replaced.png'
import selectReplaced from '@components/diagComponents/img/selectReplaced.png'

export default {
  data () {
    return {
      loading: null,
      pdfFile: this.pdfFile || '',
      xfdfStrings: [],
      instance: null,
      renameDialog: {
        showDialog: false
      },
      img: {
        linearDanger: linearDanger,
        linearPrimary: linearPrimary,
        linearSuccess: linearSuccess,
        moistureDanger: moistureDanger,
        moistureDangerWall: wallDanger,
        moistureNormal_m: moistureNormal_m,
        moistureNormal_i: moistureNormal_i,
        moistureNormal_mWall: moistureNormalWall,
        moistureComplete: moistureComplete,
        moistureCompleteWall: wallComplete,
        productDanger: productDanger,
        productDangerWall: wallDanger,
        productComplete: productComplete,
        productCompleteWall: wallComplete,
        productNormal_i: productNormal_i,
        productNormal_iWall: prodectNormalWall,
        taskDanger: taskDanger,
        taskDangerWall: wallDanger,
        taskComplete: taskComplete,
        taskCompleteWall: wallComplete,
        taskNormal: taskNormal,
        taskNormalWall: taskNormalWall,
        taskSelect: taskSelect,
        replaced: replaced,
        selectReplaced: selectReplaced
      },
      layer: null,
      currentDroppable: null,
      taskimg: {
        width: 60,
        height: 60
      },
      curTaskType: '',
      TaskType: {
        Task: 'Task',
        Product: 'Product',
        Moisture: 'Moisture',
        TaskTemplate: 'TaskTemplate'
      },
      markerList: [],
      nonM2ProductList: [],
      condition: {
        Type: null,
        Status: null,
        GroupId: null,
        DueStartTime: null,
        DueEndTime: null,
        LastUpdatedOn: null,
        AssignedUserIds: null,
        WatchingUserIds: null,
        LocationType: null
      },
      selectAnnotation: null,
      toolShows: 0,
      predefineColors: [
        'rgb(245,71,69)',
        'rgb(245,145,61)',
        'rgb(244,197,66)',
        'rgb(82,201,82)',
        'rgb(57,118,245)',
        'rgb(139,47,190)',
        'rgb(160,160,160)',
        'rgb(27,27,27)'
      ],
      toolColor: '#F54745',
      newReportDialog: {
        show: false,
        type: 1,
        taskIds: [],
        planId: '',
        isFromPdfPlan: true
      },
      isStrokeThickness: false,
      isFontSize: false,
      isSelectText: false,
      isSelectHighlight: false,
      annotationsLoaded: false,
      limitZoom: {
        in: 64,
        out: 0.05
      },
      zoomfactor: 0.2,
      taskImgSize: {
        width: 0,
        height: 0
      },
      isAnnotationSelected: false,
      pageInfo: {
        rotation: 0,
        height: 0,
        width: 0
      },
      strokeThickness: 4,
      strokeThicknessInfo: {
        strokeThickness: 4,
        highlightStrokeThickness: 48,
        minSize: 1,
        maxSize: 60
      },
      fontInfo: {
        fontSize: 67,
        minSize: 1,
        maxSize: 128
      },
      isBack: false,
      toolWidth: {
        line: 4.8,
        elipse: 4.8,
        freehand: 4.8,
        freetext: 68,
        cloudy: 4,
        rectangle: 4.8,
        highlight: 48.2
      }
    }
  },
  computed: {
    ...mapState(['plan']),
    ...mapState([
      'jobsiteID',
      'jobsiteName',
      'taskStatus',
      'taskType',
      'taskGroup',
      'projectUser',
      'taskTemplates',
      'corpId'
    ]),
    onRoute () {
      return this.$route.name
    },
    bathEdit () {
      return this.$store.state.diag.data.batchTaskIds.length > 0
    },
    list () {
      return this.$store.state.diag.data.taskList
    },
    addTaskType () {
      return parseInt(this.$store.state.diag.params.addTaskDialog.type)
    },
    addTaskDialogShow () {
      return this.$store.state.diag.params.addTaskDialog.showDialog
    },
    selectPoint () {
      return this.$store.state.diag.params.selectPoint
    },
    pinList () {
      return this.$store.state.diag.data.pinList
    },
    hasCondition () {
      return (this.condition.Type == null || this.condition.PlanId === '') &&
        (this.condition.Status == null || this.condition.Status === '') &&
        (this.condition.GroupId == null || this.condition.GroupId === '') &&
        (this.condition.DueStartTime == null || this.condition.DueStartTime === '') &&
        (this.condition.DueEndTime == null || this.condition.DueEndTime === '') &&
        (this.condition.LocationType == null || this.condition.LocationType === '') &&
        (this.condition.AssignedUserIds == null || this.condition.AssignedUserIds === '') &&
        (this.condition.WatchingUserIds == null || this.condition.WatchingUserIds === '')
    },
    taskInstallationList () {
      return this.$store.state.diag.data.taskInstallationList
    },
    addTaskPointList () {
      return this.$store.state.diag.data.addTaskPointList
    }
  },
  components: {
    pdftron,
    renameDialog,
    AddTaskDialog,
    reportConditionDialog
  },
  created () {
    this.$store.commit('diag/resetConiditon', this.condition)
    this.$store.commit('diag/resetConiditon', {
      Name: null,
      OrderBy: 'LastUpdatedOn desc',
      sortValue: 'desc',
      sortBy: 'LastUpdatedOn'
    })
  },
  mounted () {
    this.initPlan()
    this.initJobsiteData()
    this.$store.dispatch('diag/getTasksProgressOptions')
    this.$store.dispatch('getTaskWorkTypes')
    this.$store.dispatch('getTasksStatus')
    this.$store.dispatch('getTasksTypes')
    this.$store.dispatch('getTaskChecklistTemplates')
    this.$store.dispatch('getTaskTemplates')
  },
  watch: {
    jobsiteID (to, from) {
      if (to) {
        this.initJobsiteData()
      }
    },
    plan (to, from) {
      if (to) {
        this.initPlan()
      }
    },
    onRoute (to, from) {
      if (to === 'taskList2') {
        this.$store.commit('diag/setSelectPoint', {})
      }
    },
    pinList (to, from) {
      if (this.annotationsLoaded) {
        setTimeout(() => { this.addMarker(this) }, 100)
      } else {
        let that = this
        let r = new Promise((resolve) => {
          let timer = setInterval(() => {
            if (this.annotationsLoaded) {
              clearInterval(timer)
              resolve(true)
            }
          }, 100)
        })
        r.then((res) => {
          setTimeout(() => { that.addMarker(this) }, 100)
        })
      }
    },
    selectPoint (to, from) {
      if (this.isBack) {
        return
      }
      this.addMarker(this)
    }
  },
  methods: {
    initPlan () {
      this.clearFilter()
      this.$store.dispatch('diag/InstallationProductShapes')
      this.pdfFile = this.$config.baseURL + '/api/Plans/' + this.plan.PlanId + '/DownloadPdf'
    },
    initJobsiteData () {
      this.getNonM2ProductList()
      this.$store.dispatch('getTaskGroup')
      this.$store.dispatch('getProjectMember')
    },
    async handleLoaded (instance) {
      const { annotationManager, documentViewer } = instance.Core
      const annotationHistoryManager = documentViewer.getAnnotationHistoryManager()
      this.instance = instance
      this.initPdfInstanceSetting()
      let that = this
      that.pdfZoomUpdated(that, documentViewer)
      that.pdfAnnotationChanged(that, annotationManager)
      that.pdfAnnotationSelected(that, annotationManager)
      that.pdfHistoryChanged(that, annotationHistoryManager)
      that.onPdfRunWheel(that, documentViewer)
      that.$store.dispatch('diag/getTasksList')
    },
    initPdfInstanceSetting () {
      this.disablePdfUnuseButton()
      this.clearPdfToolCreateDelay()
      this.disablePdfFreeformRotation()
      this.defaultPdfTool()
    },
    disablePdfUnuseButton () {
      this.instance.disableElements(['highlightToolButton', 'stickyToolButton'])
      this.instance.disableElements(['annotationCommentButton', 'linkButton', 'annotationGroupButton', 'annotationStyleEditButton'])
    },
    clearPdfToolCreateDelay () {
      const { docViewer } = this.instance
      docViewer.getTool(this.instance.Core.Tools.ToolNames.FREEHAND_HIGHLIGHT).createDelay = 0
      docViewer.getTool(this.instance.Core.Tools.ToolNames.FREEHAND).createDelay = 0
    },
    disablePdfFreeformRotation () {
      const annotManager = this.instance.Core.documentViewer.getAnnotationManager()
      annotManager.setRotationOptions({
        isEnabled: false
      })
    },
    defaultPdfTool () {
      this.pan()
    },
    pdfZoomUpdated (that, documentViewer) {
      documentViewer.addEventListener('zoomUpdated', (zoom) => {
        const zoomLayer = that.layer || null
        if (zoomLayer) {
          const { docViewer, iframeWindow } = that.instance
          const pageContainer = iframeWindow.document.getElementById('pageContainer' + docViewer.getCurrentPage())
          if (!pageContainer.querySelector('.layer') && window.event) {
            const displayMode = docViewer.getDisplayModeManager().getDisplayMode()
            let mouseLocation = that.getMouseLocation(window.event, docViewer)
            const windowCoordinates = { x: mouseLocation.x - that.taskImgSize.width / 2, y: mouseLocation.y - that.taskImgSize.height }
            const clickedPage = that.getCurrentPage(windowCoordinates, docViewer)
            let pageCoordinates = displayMode.windowToPage(windowCoordinates, clickedPage)
            const rotatedCoordinates = that.getRotatedCoordinates(pageCoordinates)
            let left = rotatedCoordinates.x * zoom
            let top = rotatedCoordinates.y * zoom
            zoomLayer.style.left = left + 'px'
            zoomLayer.style.top = top + 'px'
            pageContainer.appendChild(zoomLayer)
          }
        }
        return
        // 由于设置了nozoom,所以这个暂时没用，后续完整后再删掉
        if (that.instance) {
          const markerLen = that.markerList.length
          if (markerLen == 0) {
            return
          }
          const { annotManager } = that.instance
          that.setTaskImgSize(zoom)
          for (let index = 0; index < markerLen; index++) {
            const element = that.markerList[index]
            element.Width = that.taskImgSize.width / zoom
            element.Height = that.taskImgSize.height / zoom
            annotManager.updateAnnotation(element)
          }
          if (that.selectAnnotation) {
            that.selectAnnotation.Width = that.taskImgSize.width / zoom
            that.selectAnnotation.Height = that.taskImgSize.height / zoom
            annotManager.updateAnnotation(that.selectAnnotation)
          }
        }
      })
    },
    pdfAnnotationChanged (that, annotationManager) {
      annotationManager.addEventListener('annotationChanged', (annotations, action, { imported }) => {
        if (imported) return
        if (!annotations || annotations.length == 0) return
        const anotCount = annotations.length
        if (action === 'delete') {
          let taskIds = []
          for (let index = 0; index < anotCount; index++) {
            const element = annotations[index]
            const isDeleteMarker = element.getCustomData('isDeleteTask')
            if (isDeleteMarker === '') {
              let taskId = element.getCustomData('taskid')
              if (taskId !== '') {
                if (taskId == 'selectAnnotation') {
                  const pointX = element.getCustomData('pointX')
                  const pointY = element.getCustomData('pointY')
                  const sPin = that.pinList.find(pin => pin.point.x.toString() === pointX && pin.point.y.toString() === pointY)
                  if (sPin) {
                    taskId = sPin.taskId
                  }
                }
                taskIds.push(taskId)
              }
            }
          }
          if (taskIds.length > 0) {
            that.deleteTask(that, taskIds)
            return
          }
        }
        for (let index = 0; index < anotCount; index++) {
          const annotation = annotations[index]
          let markupType = that.getMarkupTypeByToolName(that, annotation.ToolName)
          if (markupType == 0) {
            continue
          }
          if (markupType == 4) {
            if (annotation.Style.toLowerCase() === 'cloudy') {
              markupType = 11
            }
          }
          let isDeleted = action === 'delete'
          let anotId = annotation.Id
          let xfdfString = that.getAnnotationXfdfString(that, annotations[index], markupType)
          that.saveAnotXmlStr(that, anotId, markupType, isDeleted, xfdfString)
        }
      })
    },
    pdfAnnotationSelected (that, annotationManager) {
      annotationManager.addEventListener('annotationSelected', (annotations, action) => {
        if (action === 'selected') {
          if (annotations && annotations.length == 1) {
            const { Annotations } = that.instance
            const annotation = annotations[0]
            if (annotation instanceof Annotations.StampAnnotation) {
              if (that.selectAnnotation) {
                that.isAnnotationSelected = true
              }
              if (!that.selectAnnotation || that.selectAnnotation.Id != annotation.Id) {
                that.isAnnotationSelected = true
                let pointX = parseFloat(annotation.getCustomData('pointX'))
                let pointY = parseFloat(annotation.getCustomData('pointY'))
                let point = {
                  x: pointX,
                  y: pointY
                }
                that.$store.commit('diag/setSelectPoint', point)
                let isRoute = true
                if (that.selectAnnotation) {
                  isRoute = that.selectAnnotation.getCustomData('taskid') != annotation.getCustomData('taskid')
                }
                if (isRoute) {
                  that.$router.push({
                    name: 'modelTask2',
                    params: {
                      id: annotation.getCustomData('taskid')
                    }
                  })
                }
              }
            } else {
              if (annotation instanceof Annotations.FreeTextAnnotation) {
                that.toolColor = annotation.TextColor.toHexString()
                // that.fontInfo.fontSize = parseInt(annotation.FontSize)
                that.isSelectText = true
              } else {
                that.toolColor = annotation.StrokeColor.toHexString()
                if (annotation instanceof Annotations.TextHighlightAnnotation) {
                  // that.strokeThicknessInfo.highlightStrokeThickness = parseInt(annotation.StrokeThickness)
                  that.isSelectHighlight = true
                } else {
                  // that.strokeThicknessInfo.strokeThickness = parseInt(annotation.StrokeThickness)
                  that.isSelectText = false
                  that.isSelectHighlight = false
                }
              }
            }
          }
        } else if (action === 'deselected') {
          that.isStrokeThickness = false
          that.isFontSize = false
          that.isSelectText = false
          that.isSelectHighlight = false
          // that.getAnnotationToolStyle()
          console.log('annotation deselection');
        }

        if (annotations === null && action === 'deselected') {
          console.log('all annotations deselected')
        }

        if (!that.isAnnotationSelected && !that.getIsClickDeleteTrigger(that)) {
          if (null != that.selectAnnotation) {
            that.$store.commit('diag/setSelectPoint', {})
            that.$router.push({
              name: 'taskList2'
            })
          }
        }
      })
    },
    pdfHistoryChanged (that, annotationHistoryManager) {
      annotationHistoryManager.addEventListener('historyChanged', () => {
        if (annotationHistoryManager.action === 'add' && that.toolShows === that.getToolNumberByToolName(that, annotationHistoryManager)) {
          that.defaultPdfTool()
        }
      })
    },
    onPdfRunWheel (that, documentViewer) {
      const doc = documentViewer.getDocument()
      if (doc.getPageCount() === 1) {
        that.runWheel(that.instance.iframeWindow)
      }
      that.$store.dispatch('diag/getTasksList')
    },
    getAnnotationXfdfString (that, annotation, markupType) {
      let xmldoc = null
      let element = null
      switch (markupType) {
        case 1:
          xmldoc = that.loadXmlStr('<line tail="OpenArrow"/>')
          element = xmldoc.children[0]
          element.setAttribute('width', annotation.StrokeThickness)
          element.setAttribute('color', annotation.Color.toHexString())
          element.setAttribute('start', that.getPointStr(that, annotation.PageNumber, annotation.Start.x, annotation.Start.y))
          element.setAttribute('end', that.getPointStr(that, annotation.PageNumber, annotation.End.x, annotation.End.y))
          break
        case 2:
          xmldoc = that.loadXmlStr('<line head="OpenArrow" tail="OpenArrow" caption="yes" caption-style="Top"><contents></contents><measure scale=""></measure></line>')
          element = xmldoc.children[0]
          element.setAttribute('width', annotation.StrokeThickness)
          element.setAttribute('color', annotation.Color.toHexString())
          element.setAttribute('start', that.getPointStr(that, annotation.PageNumber, annotation.Start.x, annotation.Start.y))
          element.setAttribute('end', that.getPointStr(that, annotation.PageNumber, annotation.End.x, annotation.End.y))
          xmldoc.getElementsByTagName('contents')[0].innerHTML = annotation.getContents()
          xmldoc.getElementsByTagName('measure')[0].setAttribute('scale', that.getScaleStr(annotation.Scale))
          break
        case 3:
          xmldoc = that.loadXmlStr('<freetext subject="Free Text"><contents></contents></freetext>')
          element = xmldoc.children[0]
          // element.setAttribute('width', annotation.StrokeThickness)
          element.setAttribute('TextColor', annotation.TextColor.toHexString())
          element.setAttribute('FontSize', parseInt(annotation.FontSize))
          xmldoc.getElementsByTagName('contents')[0].innerHTML = annotation.getContents()
          break
        case 4:
          xmldoc = that.loadXmlStr('<square subject="Rectangle" />')
          element = xmldoc.children[0]
          element.setAttribute('color', annotation.Color.toHexString())
          element.setAttribute('width', annotation.StrokeThickness)
          break
        case 5:
          xmldoc = that.loadXmlStr('<ink subject="Free Hand"><inklist><gesture></gesture></inklist></ink>')
          element = xmldoc.children[0]
          element.setAttribute('width', annotation.StrokeThickness)
          element.setAttribute('color', annotation.Color.toHexString())
          xmldoc.getElementsByTagName('gesture')[0].innerHTML = that.getGesture(that, annotation.PageNumber, annotation.getPath())
          break
        case 7:
          xmldoc = that.loadXmlStr('<ink subject="Free Hand Highlight"><inklist><gesture></gesture></inklist></ink>')
          element = xmldoc.children[0]
          element.setAttribute('color', annotation.Color.toHexString())
          element.setAttribute('width', annotation.StrokeThickness)
          element.setAttribute('opacity', annotation.Opacity)
          xmldoc.getElementsByTagName('gesture')[0].innerHTML = that.getGesture(that, annotation.PageNumber, annotation.getPath())
          break
        case 8:
          xmldoc = that.loadXmlStr('<line />')
          element = xmldoc.children[0]
          element.setAttribute('color', annotation.Color.toHexString())
          element.setAttribute('width', annotation.StrokeThickness)
          element.setAttribute('start', that.getPointStr(that, annotation.PageNumber, annotation.Start.x, annotation.Start.y))
          element.setAttribute('end', that.getPointStr(that, annotation.PageNumber, annotation.End.x, annotation.End.y))
          break
        case 9:
          xmldoc = that.loadXmlStr('<circle />')
          element = xmldoc.children[0]
          element.setAttribute('color', annotation.Color.toHexString())
          element.setAttribute('subject', annotation.Subject)
          element.setAttribute('width', annotation.StrokeThickness)
          break
        case 11:
          xmldoc = that.loadXmlStr('<square subject="Rectangle" style="cloudy" intensity="2"/>')
          element = xmldoc.children[0]
          element.setAttribute('color', annotation.Color.toHexString())
          element.setAttribute('width', annotation.StrokeThickness)
          break
        default:
          break
      }
      if (element && that.isSetRectAttr(markupType)) {
        element.setAttribute('rect', that.getRectStr(that, annotation.PageNumber, annotation.getRect()))
      }
      let result = ''
      if (xmldoc) {
        result = that.parserXMLToString(xmldoc)
      }
      return result
    },
    isSetRectAttr (markupType) {
      const notMarkupArray = [1, 2, 5, 7, 8]
      return notMarkupArray.indexOf(markupType) == -1
    },
    getGesture (that, page, paths) {
      let gestureArray = []
      // const points = annotation.getPath()
      if (paths && paths.length > 0) {
        const doc = that.instance.Core.documentViewer.getDocument()
        // const page = annotation.PageNumber
        let viewerCoordinate = null
        paths.forEach(p => {
          viewerCoordinate = doc.getViewerCoordinates(page, p.x, p.y)
          if (viewerCoordinate) {
            gestureArray.push(viewerCoordinate.x + ',' + viewerCoordinate.y)
          }
        })
      }
      return gestureArray.join(';')
    },
    getScaleStr (scale) {
      return scale[0][0] + ' ' + scale[0][1] + ' = ' + scale[1][0] + ' ' + scale[1][1]
    },
    getPointStr (that, page, x, y) {
      const doc = that.instance.Core.documentViewer.getDocument()
      const point = doc.getViewerCoordinates(page, x, y)
      return point.x + ',' + point.y
    },
    getRectStr (that, page, rect) {
      const doc = that.instance.Core.documentViewer.getDocument()
      const point1 = doc.getViewerCoordinates(page, rect.x1, rect.y1)
      const point2 = doc.getViewerCoordinates(page, rect.x2, rect.y2)
      return point1.x + ',' + point2.y + ',' + point2.x + ',' + point1.y
    },
    getIsClickDeleteTrigger (that) {
      return false
      // 目前还不能做到删除task提示时点击取消的还原动作，所以先不用判断是否来自删除触发的
      if (that.instance.iframeWindow.event && that.instance.iframeWindow.event.type === 'click') {
        if (that.instance.iframeWindow.event.srcElement.dataset) {
          return that.instance.iframeWindow.event.srcElement.dataset.element === 'annotationDeleteButton'
        }
      }
      return false
    },
    deleteTask (that, taskIds) {
      that.$confirm(that.$t('model.AreYouSureYouWantToDeleteThisTask'), that.$t('model.TIPS'), {
        confirmButtonText: that.$t('model.Yes'),
        cancelButtonText: that.$t('model.No'),
        type: 'warning'
      }).then(() => {
        deleteTask(taskIds).then(res => {
          that.$notify({
            title: that.$t('api.Successfully'),
            type: 'success',
            showClose: false
          })
          that.$store.dispatch('diag/getTasksList')
        })
      }).catch(() => {
      })
    },
    runWheel (iframeWindow) {
      if (iframeWindow.addEventListener) {
        iframeWindow.addEventListener('DOMMouseScroll', this.handleScroll, { passive: false })
        iframeWindow.addEventListener('mousewheel', this.handleScroll, { passive: false });
      } else {
        if (iframeWindow.attachEvent) {
          iframeWindow.attachEvent('onmousewheel', this.handleScroll, { passive: false })
        }
      }
      // iframeWindow.onmousewheel = iframeWindow.document.onmousewheel = this.handleScroll
    },
    isTargetCanScroll (e) {
      if (e.target.localName === 'canvas') {
        return true
      }
      if (e.target.localName === 'div' || e.target.parentElement.localName === 'div') {
        if (e.target.id.startsWith('pageWidgetContainer') || e.target.className === 'DocumentContainer'
          || e.target.className === 'layer' || e.target.parentElement.className === 'layer') {
          return true
        }
      }
      return false
    },
    handleScroll (e) {
      if (e.target) {
        if (this.isTargetCanScroll(e)) {
          let delta = 0
          if (e.wheelDelta) {
            delta = e.wheelDelta / 120
            if (window.opera) delta = -delta
          } else if (e.detail) {
            delta = -e.detail / 3
          }
          if (delta > 0) {
            this.zoom(1, true)
          } else {
            this.zoom(0, true)
          }
          e.preventDefault()
          e.stopPropagation()
        }
      }
    },
    handlePageComplete (pageNumber, canvas, isLoadDocument) {
      if (this.instance) {
        this.setPageInfo(pageNumber)
      }
      if (!this.annotationsLoaded || isLoadDocument) {
        this.loadXfdfStrings()
        this.annotationsLoaded = true
      }
    },
    async loadXfdfStrings () {
      let pageIndex = 1
      let pageSize = 20
      let pageCount = 1
      const { annotationManager } = this.instance.Core
      do {
        let res = await this.getPdfMarkups(pageIndex, pageSize)
        pageCount = res.PageCount
        pageIndex = pageIndex + 1
        if (res.Data && res.Data.length > 0) {
          const xmlTemplate = '<?xml version="1.0" encoding="utf-8"?>\
                          <xfdf xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve">\
                          <annots>\
                          </annots>\
                          </xfdf>'
          let xmlDoc = this.loadXmlStr(xmlTemplate)
          if (xmlDoc) {
            let annots = xmlDoc.getElementsByTagName('annots')
            if (annots && annots.length > 0) {
              annots[0].innerHTML = this.getXfdfStrings(res.Data)
              this.initAnnots(annots[0], res.Data)
              let xfdfString = this.parserXMLToString(xmlDoc)
              annotationManager.importAnnotations(xfdfString)
            }
          }
        }
      } while (pageIndex <= pageCount)
    },
    initAnnots (annot, data) {
      if (annot.children) {
        const len = annot.children.length
        const dataLen = data.length
        if (len > 0 && len == dataLen) {
          for (let index = 0; index < len; index++) {
            const element = annot.children[index]
            if (!element.getAttribute('page')) {
              element.setAttribute('page', '0')
            }
            if (!element.getAttribute('name')) {
              element.setAttribute('name', data[index].MarkupId)
            }
            if (!element.getAttribute('rotation')) {
              element.setAttribute('rotation', this.pageInfo.rotation * 90)
            }
            if (!element.getAttribute('flags')) {
              element.setAttribute('flags', 'print')
            }
          }
        }
      }
    },
    getXfdfStrings (resData) {
      let len = resData.length
      let array = []
      for (let index = 0; index < len; index++) {
        array.push(resData[index].Shape)
      }
      return array.join('')
    },
    async getPdfMarkups (pageIndex, pageCount) {
      let condition = {
        JobsiteId: this.jobsiteID,
        PlanId: this.plan.PlanId,
        TaskId: '',
        GetRecycle: false,
        LastUpdatedOn: '',
        PageIndex: pageIndex,
        PageSize: pageCount
      }
      return await getMarkup(condition)
    },
    getMarkupTypeByToolName (that, toolName) {
      let markupType = 0
      switch (toolName) {
        case that.instance.Core.Tools.ToolNames.ARROW:
          markupType = 1
          break
        case that.instance.Core.Tools.ToolNames.DISTANCE_MEASUREMENT:
          markupType = 2
          break
        case that.instance.Core.Tools.ToolNames.FREETEXT:
          markupType = 3
          break
        case that.instance.Core.Tools.ToolNames.FREEHAND_HIGHLIGHT:
          markupType = 7
          break
        case that.instance.Core.Tools.ToolNames.FREEHAND:
          markupType = 5
          break
        case that.instance.Core.Tools.ToolNames.ELLIPSE:
          markupType = 9
          break
        case that.instance.Core.Tools.ToolNames.RECTANGLE:
          markupType = 4
          break
        case that.instance.Core.Tools.ToolNames.LINE:
          markupType = 8
          break
        default:
          break
      }
      return markupType
    },
    getToolNumberByToolName (that, annotationHistoryManager) {
      let toolNumber = that.toolShows
      if (annotationHistoryManager.Jb && annotationHistoryManager.Jb.length == 1) {
        const toolName = annotationHistoryManager.Jb[0].ToolName
        switch (toolName) {
          case that.instance.Core.Tools.ToolNames.ARROW:
            toolNumber = 1
            break
          case that.instance.Core.Tools.ToolNames.DISTANCE_MEASUREMENT:
            toolNumber = 2
            break
          case that.instance.Core.Tools.ToolNames.FREETEXT:
            toolNumber = 4
            break
          case that.instance.Core.Tools.ToolNames.FREEHAND_HIGHLIGHT:
            toolNumber = 3
            break
          case that.instance.Core.Tools.ToolNames.FREEHAND:
            toolNumber = 5
            break
          case that.instance.Core.Tools.ToolNames.ELLIPSE:
            toolNumber = 7
            break
          case that.instance.Core.Tools.ToolNames.RECTANGLE:
            if (annotationHistoryManager.Jb[0].Style === 'solid') {
              toolNumber = 9
            } else {
              toolNumber = 6
            }
            break
          case that.instance.Core.Tools.ToolNames.LINE:
            toolNumber = 8
            break
          default:
            break
        }
      }
      return toolNumber
    },
    saveAnotXmlStr (that, anotId, markupType, isDeleted, xfdfString) {
      let data = [{
        MarkupId: anotId,
        CorpId: that.corpId,
        JobsiteId: that.jobsiteID,
        PlanId: that.plan.PlanId,
        TaskId: '',
        MarkupType: markupType,
        Shape: xfdfString,
        MarkupCategory: 2,
        IsDeleted: isDeleted
      }]
      addMarkup(data).then(res => {
        console.log('res', res)
      })
    },
    getAnotXmlStr (xfdfString) {
      let xmldoc = this.loadXmlStr(xfdfString)
      if (xmldoc) {
        let annots = xmldoc.getElementsByTagName('annots')
        if (annots && annots.length > 0) {
          return annots[0].innerHTML
        }
      }
      return xfdfString
    },
    loadXmlStr (xmlStr) {
      let xmlDoc = null
      if (window.DOMParser) {
        let parse = new DOMParser()
        xmlDoc = parse.parseFromString(xmlStr, 'text/xml')
      } else {
        if (window.ActiveXObject) {
          xmlDoc = new ActiveXObject("Microsoft.XMLDOM")
          xmlDoc.async = false
          xmlDoc.loadXML(xmlDoc)
        }
      }
      return xmlDoc
    },
    parserXMLToString (xmlDOM) {
      if (window.ActiveXObject) {
        return xmlDOM.xml
      } else if (document.implementation
        && document.implementation.createDocument) {
        return new XMLSerializer().serializeToString(xmlDOM)
      }
    },
    search () {
      this.$store.dispatch('diag/search', this.condition)
    },
    select (index, indexPath) {
      this.$router.push({
        name: index
      })
    },
    getToolStyle () {
      const { Annotations } = this.instance
      let colors = this.hexToRgb(this.toolColor)
      let newStyle = new Object
      // if (this.toolShows == 3) {
      //   this.strokeThickness = this.strokeThicknessInfo.highlightStrokeThickness
      //   newStyle.StrokeThickness = this.strokeThicknessInfo.highlightStrokeThickness
      // } else {
      //   this.strokeThickness = this.strokeThicknessInfo.strokeThickness
      //   newStyle.StrokeThickness = this.strokeThicknessInfo.strokeThickness
      // }
      newStyle.StrokeThickness = this.getToolWidth()
      newStyle.StrokeColor = new Annotations.Color(colors[0], colors[1], colors[2])
      return newStyle
    },
    getToolWidth () {
      let width = 4
      switch (this.toolShows) {
        case 1:
        case 8:
          width = this.toolWidth.line
          break
        case 3:
          width = this.toolWidth.highlight
          break
        case 4:
          width = this.toolWidth.freetext
          break
        case 5:
          width = this.toolWidth.freehand
          break
        case 6:
          width = this.toolWidth.cloudy
          break
        case 7:
          width = this.toolWidth.elipse
          break
        case 9:
          width = this.toolWidth.rectangle
          break
        default:
          break
      }
      return width
    },
    pan () {
      this.toolShows = 0
      if (this.instance) {
        const { documentViewer } = this.instance.Core
        let tool = documentViewer.getTool(this.instance.Core.Tools.ToolNames.PAN)
        documentViewer.setToolMode(tool)
      }
    },
    arrow () {
      this.toolShows = 1
      this.setTool(this.instance.Core.Tools.ToolNames.ARROW)
    },
    measure () {
      this.toolShows = 2
      if (this.instance) {
        let style = this.getToolStyle()
        // style.FontSize = style.StrokeThickness + 'pt'
        this.setTool(this.instance.Core.Tools.ToolNames.DISTANCE_MEASUREMENT, style)
      }
    },
    highlight () {
      this.toolShows = 3
      this.setTool(this.instance.Core.Tools.ToolNames.FREEHAND_HIGHLIGHT)
    },
    freetext () {
      this.toolShows = 4
      if (this.instance) {
        let style = this.getToolStyle()
        let newStyle = new Object
        newStyle.FontSize = style.StrokeThickness + 'pt'
        newStyle.TextColor = style.StrokeColor
        newStyle.StrokeThickness = 0
        newStyle.StrokeColor = new this.instance.Annotations.Color(0, 0, 0, 1)
        this.setTool(this.instance.Core.Tools.ToolNames.FREETEXT, newStyle)
      }
    },
    ink () {
      this.toolShows = 5
      this.setTool(this.instance.Core.Tools.ToolNames.FREEHAND)
    },
    cloudy () {
      this.toolShows = 6
      if (this.instance) {
        let newStyle = this.getToolStyle()
        newStyle.Style = 'cloudy'
        this.setTool(this.instance.Core.Tools.ToolNames.RECTANGLE, newStyle)
      }
    },
    ellipe () {
      this.toolShows = 7
      this.setTool(this.instance.Core.Tools.ToolNames.ELLIPSE)
    },
    rectangle () {
      this.toolShows = 9
      if (this.instance) {
        let newStyle = this.getToolStyle()
        newStyle.Style = 'solid'
        this.setTool(this.instance.Core.Tools.ToolNames.RECTANGLE, newStyle)
      }
    },
    line () {
      this.toolShows = 8
      this.setTool(this.instance.Core.Tools.ToolNames.LINE)
    },
    setTool (toolName, toolStyle) {
      if (this.instance) {
        const { documentViewer } = this.instance.Core
        let tool = documentViewer.getTool(toolName)
        toolStyle = toolStyle || null
        if (!toolStyle) {
          toolStyle = this.getToolStyle()
        }
        tool.setStyles(toolStyle)
        documentViewer.setToolMode(tool)
        this.isStrokeThickness = false
        this.isFontSize = false
      }
    },
    setColor () {
      if (this.instance) {
        const { annotManager, Annotations } = this.instance;
        const selectedAnnots = annotManager.getSelectedAnnotations();
        if (selectedAnnots.length > 0) {
          let colors = this.hexToRgb(this.toolColor)
          let newColor = new Annotations.Color(colors[0], colors[1], colors[2])
          selectedAnnots.forEach(annotation => {
            let newStyle = new Object
            if (annotation instanceof Annotations.FreeTextAnnotation) {
              newStyle.TextColor = newColor
            } else {
              newStyle.StrokeColor = newColor
            }
            annotManager.setAnnotationStyles(annotation, newStyle)
          })
        }
        this.resetTool()
        // this.setAnnotationToolStyle()
      }
    },
    hexToRgb (hex) {
      var colors = [0, 0, 0]
      var reg = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/
      if (reg.test(hex)) {
        var hex = hex.slice(1)
        if (hex.length === 3) {
          for (var i = 0; i < 3; i++) {
            colors[i] = parseInt(hex[i] + hex[i], 16)
          }
        } else if (hex.length === 6) {
          for (var i = 0; i < 3; i++) {
            colors[i] = parseInt('0x' + hex.substr(i * 2, 2));
          }
        }
      }
      return colors
    },
    rgbToHex (rgb) {
      if (!/^(rgb|RGB)/.test(rgb)) {
        return rgb
      }
      var color = rgb.toString().match(/\d+/g)
      var hex = '#'
      for (var i = 0; i < 3; i++) {
        if (color[i] < 0 || color[i] > 255) {
          return rgb
        }
        hex += ('0' + Number(color[i]).toString(16)).slice(-2)
      }
      return hex
    },
    resetTool () {
      const { documentViewer } = this.instance.Core
      const toolModel = documentViewer.getToolMode()
      if (toolModel) {
        const toolName = toolModel.name
        if (toolName === this.instance.Core.Tools.ToolNames.PAN) {
          return
        }
        if (toolName === this.instance.Core.Tools.ToolNames.RECTANGLE) {
          if (toolModel.defaults.Style === 'cloudy') {
            this.cloudy()
          } else {
            this.rectangle()
          }
        } else if (toolName === this.instance.Core.Tools.ToolNames.FREETEXT) {
          this.freetext()
        } else if (toolName === this.instance.Core.Tools.ToolNames.DISTANCE_MEASUREMENT) {
          this.measure()
        } else {
          this.setTool(toolName)
        }
      }
    },
    changeStrokeThickness () {
      if (this.instance) {
        const { annotManager, Annotations } = this.instance;
        const selectedAnnots = annotManager.getSelectedAnnotations();
        if (selectedAnnots.length > 0) {
          selectedAnnots.forEach(annotation => {
            let newStyle = new Object
            if (annotation instanceof Annotations.FreeTextAnnotation) {
              newStyle.FontSize = this.fontInfo.fontSize + 'pt'
            } else if (annotation instanceof Annotations.TextHighlightAnnotation) {
              this.strokeThicknessInfo.highlightStrokeThickness = this.strokeThickness
              newStyle.StrokeThickness = this.strokeThickness
            } else {
              this.strokeThicknessInfo.strokeThickness = this.strokeThickness
              newStyle.StrokeThickness = this.strokeThickness
            }
            annotManager.setAnnotationStyles(annotation, newStyle)
          })
        }
        if (this.toolShows == 3) {
          this.strokeThicknessInfo.highlightStrokeThickness = this.strokeThickness
        } else if (this.toolShows != 4) {
          this.strokeThicknessInfo.strokeThickness = this.strokeThickness
        }
        this.resetTool()
        // this.setAnnotationToolStyle()
      }
      setTimeout(() => {
        this.isStrokeThickness = false
        this.isFontSize = false
      }, 100)
    },
    changeColor () {
      this.setColor()
    },
    getShowStrokeThickness () {
      if (this.isSelectText) {
        return this.fontInfo.fontSize
      } else if (this.isSelectHighlight) {
        return this.strokeThicknessInfo.highlightStrokeThickness
      }
      let thickness
      switch (this.toolShows) {
        case 4:
          thickness = this.fontInfo.fontSize
          break
        case 3:
          thickness = this.strokeThicknessInfo.highlightStrokeThickness
          break
        default:
          thickness = this.strokeThicknessInfo.strokeThickness
          break
      }
      return thickness
    },
    setStrokeThickness () {
      if (this.toolShows == 4 || this.isSelectText) {
        this.isFontSize = !this.isFontSize
      } else {
        this.isStrokeThickness = !this.isStrokeThickness
      }
    },
    addTask (e, dragType) {
      this.setTask(e, dragType)
    },
    clearFilter () {
      this.condition = {
        Type: null,
        Status: null,
        GroupId: null,
        DueStartTime: null,
        DueEndTime: null,
        LastUpdatedOn: null,
        AssignedUserIds: null,
        WatchingUserIds: null,
        LocationType: null
      }
      this.$store.dispatch('diag/search', this.condition)
    },
    addMarker (that) {
      that.removeMarker(that)
      if (that.markerList.length == 0) {
        for (const ele of that.pinList) {
          ele.replaced = false
          if (ele.pin === 'product') {
            for (let i of this.taskInstallationList) {
              if (ele.taskId === i.TaskId) {
                let hasProduct = true
                if (i.ProductSkus.length > 0 && ele.taskSubtype === 1) {
                  hasProduct = that.compareProducts(that.nonM2ProductList, i.ProductSkus)
                }
                if (ele.pinColor === 'Complete' || (ele.taskSubtype === 1 && hasProduct)) {
                  ele.replaced = false
                } else {
                  if (i.ProductSkus.length < 1 && (i.RoomId === '' || i.RoomId === null) && i.ShapeIds.length < 1) {
                    ele.replaced = false
                  } else {
                    if (i.ShapeIds.length > 0 && i.RoomId === null) {
                      ele.replaced = false
                    } else {
                      if (hasRoom && hasProduct) {
                        ele.replaced = false
                      } else if (!hasRoom || !hasProduct) {
                        ele.replaced = true
                      }
                    }
                  }
                }
              }
            }
          }
          let obj = {}
          obj.TaskId = ele.taskId
          let img
          let isSelect = false
          if (ele.replaced) {
            obj.replaced = true
            if (isSelect) {
              img = that.img.selectReplaced
            } else {
              img = that.img.replaced
            }
          } else {
            if (isSelect) {
              img = that.img.taskSelect
            } else {
              if (ele.position) {
                img = eval('that.img.' + ele.pin + ele.pinColor + ele.position)
              } else {
                img = eval('that.img.' + ele.pin + ele.pinColor)
              }
            }
          }

          that.createTaskImgAnnotation(img, ele.point.x, ele.point.y, ele.taskId, function (createdAnnotation) {
            obj.annotation = createdAnnotation
            that.markerList.push(obj.annotation)
          })
        }
      }
      if (that.selectAnnotation) {
        let toDeleteAnnotation = that.selectAnnotation
        that.selectAnnotation = null
        toDeleteAnnotation.setCustomData('isDeleteTask', '1')
        toDeleteAnnotation.Locked = false
        that.instance.annotManager.deleteAnnotation(toDeleteAnnotation)
      }
      if (that.selectPoint && that.selectPoint.x) {
        const simg = that.img.taskSelect
        that.createTaskImgAnnotation(simg, that.selectPoint.x, that.selectPoint.y, 'selectAnnotation', function (createdAnnotation) {
          that.selectAnnotation = createdAnnotation
          const { annotationManager } = that.instance.Core
          annotationManager.selectAnnotation(createdAnnotation)
          that.isAnnotationSelected = false
        })
      }
    },
    compareProducts (p1, p2) {
      for (let a of p2) {
        if (!p1.find(y => y.SKU === a)) {
          return false
        }
      }
      return true
    },
    getMouseLocation (e, docViewer) {
      const scrollElement = docViewer.getScrollViewElement()
      const scrollLeft = scrollElement.scrollLeft || 0
      const scrollTop = scrollElement.scrollTop || 0
      return { x: e.x + scrollLeft, y: e.y + scrollTop }
    },
    getRotatedCoordinates (pageCoordinates) {
      if (this.pageInfo && this.pageInfo.height) {
        switch (this.pageInfo.rotation) {
          case 1:
            const srcX = pageCoordinates.x
            pageCoordinates.x = this.pageInfo.height - pageCoordinates.y
            pageCoordinates.y = srcX
            // pageCoordinates.y = this.pageInfo.height - pageCoordinates.y
            break
          case 2:
            pageCoordinates.x = this.pageInfo.width - pageCoordinates.x
            pageCoordinates.y = this.pageInfo.height - pageCoordinates.y
            break
          case 3:
            const srcY = pageCoordinates.y
            pageCoordinates.y = this.pageInfo.width - pageCoordinates.x
            pageCoordinates.x = srcY
            break
        }
      }
      return pageCoordinates
    },
    getRotatedTaskWindowCoordinates (mouseLocation) {
      if (this.pageInfo && this.pageInfo.height) {
        const diffX = this.taskImgSize.width / 2
        switch (this.pageInfo.rotation) {
          case 0:
            mouseLocation.x = mouseLocation.x - diffX
            mouseLocation.y = mouseLocation.y - this.taskImgSize.height
            break
          case 1:
            mouseLocation.x = mouseLocation.x + diffX
            mouseLocation.y = mouseLocation.y - this.taskImgSize.height
            break
          case 2:
            mouseLocation.x = mouseLocation.x + diffX
            break
          case 3:
            mouseLocation.x = mouseLocation.x - diffX
            break
          default:
            break
        }
      }
      return mouseLocation
    },
    getRotatedTaskViewCoordinates (viewCoordinates, zoom) {
      if (this.pageInfo && this.pageInfo.height) {
        const diffX = this.taskImgSize.width / 2
        switch (this.pageInfo.rotation) {
          case 0:
            viewCoordinates.x = viewCoordinates.x - diffX / zoom
            viewCoordinates.y = viewCoordinates.y - this.taskImgSize.height / zoom
            break
          case 1:
            viewCoordinates.x = viewCoordinates.x - this.taskImgSize.height / zoom
            viewCoordinates.y = viewCoordinates.y - diffX / zoom
            break
          case 2:
            viewCoordinates.x = viewCoordinates.x - diffX / zoom
            break
          case 3:
            viewCoordinates.y = viewCoordinates.y - diffX / zoom
            break
          default:
            break
        }
      }
      return viewCoordinates
    },
    setPageInfo (pageNumber) {
      const { documentViewer } = this.instance.Core
      this.pageInfo.rotation = parseInt(documentViewer.getCompleteRotation(pageNumber))
      this.pageInfo.height = documentViewer.getPageHeight(pageNumber)
      this.pageInfo.width = documentViewer.getPageWidth(pageNumber)
    },
    parallax (e) {
      const { docViewer, iframeWindow } = this.instance
      let layer = this.getLayer(iframeWindow)
      if (layer) {
        e.stopPropagation()
        const displayMode = docViewer.getDisplayModeManager().getDisplayMode()
        let mouseLocation = this.getMouseLocation(e, docViewer)
        // const windowCoordinates = this.getRotatedTaskWindowCoordinates(mouseLocation)
        const windowCoordinates = { x: mouseLocation.x - this.taskImgSize.width / 2, y: mouseLocation.y - this.taskImgSize.height }
        const clickedPage = this.getCurrentPage(windowCoordinates, docViewer)
        let pageCoordinates = displayMode.windowToPage(windowCoordinates, clickedPage)
        const zoom = this.getZoom(docViewer)
        const rotatedCoordinates = this.getRotatedCoordinates(pageCoordinates)
        let left = rotatedCoordinates.x * zoom
        let top = rotatedCoordinates.y * zoom
        layer.style.left = left + 'px'
        layer.style.top = top + 'px'

        layer.hidden = true
        let elemBelow = iframeWindow.document.elementFromPoint(
          e.clientX,
          e.clientY
        )
        layer.hidden = false
        if (!elemBelow) return
        let droppableBelow = elemBelow.closest('.task-droppable')
        if (this.currentDroppable != droppableBelow) {
          this.currentDroppable = droppableBelow
        }
      }
    },
    getLayer (iframeWindow) {
      if (!this.layer) {
        this.layer = iframeWindow.document.querySelector('.layer')
      }
      return this.layer
    },
    parallaxdown (e) {
      const { iframeWindow } = this.instance
      let layer = this.getLayer(iframeWindow)
      if (layer) {
        e.stopPropagation()
      }
      if (!this.currentDroppable) {
        return false
      }
      try {
        if (e.button === 0) {
          this.addDragMarker(this.curTaskType, e)
        } else {
          this.removeTask(e)
        }
      } catch (e) {
        this.removeTask(e)
      }
    },
    removeTask (e) {
      const windowCoordinates = this.getWindowCoordinates(e)
      this.removeTaskByWindowCoordinates(windowCoordinates)
    },
    removeTaskByWindowCoordinates (windowCoordinates) {
      const { docViewer, iframeWindow } = this.instance
      const clickedPage = this.getCurrentPage(windowCoordinates, docViewer)
      const pageContainer = iframeWindow.document.getElementById('pageContainer' + clickedPage)
      pageContainer.classList.remove('task-droppable')
      if (this.layer) {
        this.layer.style.display = 'none'
      }
      const documentContainerDiv = this.getInstanceDocumentContainerDiv()
      if (documentContainerDiv) {
        documentContainerDiv.removeEventListener('mousemove', this.parallax, {
          capture: true
        })
        documentContainerDiv.removeEventListener('mousedown', this.parallaxdown, {
          capture: true
        })
      }
    },
    createInstanceDiv (className, cssText) {
      let div = document.createElement('div')
      div.className = className
      div.style.cssText = cssText
      return div
    },
    getTaskImgDivCssText (top, left) {
      return `z-index: 35;position: absolute;top:${top}px;left:${left}px`
    },
    createInstanceImg (src, width, height, className) {
      let img = this.instance.iframeWindow.document.createElement('img')
      img.src = src
      img.width = width
      img.height = height
      img.className = className
      return img
    },
    getTaskImgSrcByTaskType (taskType) {
      let imgName = 'taskNormal'
      switch (taskType) {
        case this.TaskType.Task:
        case this.TaskType.TaskTemplate:
          imgName = 'taskNormal'
          break
        case this.TaskType.Product:
          imgName = 'productNormal_i'
          break
        case this.TaskType.Moisture:
          imgName = 'moistureNormal_m'
          break
      }
      return eval('this.img.' + imgName)
    },
    getInstanceDocumentContainerDiv () {
      return this.instance.iframeWindow.document.querySelector('[data-element="documentContainer"]')
    },
    getWindowCoordinates (e) {
      return this.getCoordinates(e.pageX, e.pageY)
    },
    getCoordinates (x, y) {
      return { x: x, y: y }
    },
    getCurrentPage (windowCoordinates, docViewer) {
      const displayMode = docViewer.getDisplayModeManager().getDisplayMode()
      const page = displayMode.getSelectedPages(windowCoordinates, windowCoordinates)
      return (page.first !== null) ? page.first : docViewer.getCurrentPage()
    },
    getPageCoordinates (e, docViewer) {
      const windowCoordinates = this.getWindowCoordinates(e)
      return this.windowToPage(windowCoordinates, docViewer)
    },
    windowToPage (windowCoordinates, docViewer) {
      const displayMode = docViewer.getDisplayModeManager().getDisplayMode()
      const clickedPage = this.getCurrentPage(windowCoordinates, docViewer)
      return displayMode.windowToPage(windowCoordinates, clickedPage)
    },
    getZoom (docViewer) {
      return docViewer.getZoomLevel()
    },
    getLengthByZoom (length, zoom) {
      return length
      //下面是按照zoom的一个限制大小的线性比例换算，因为看到之前diag web task是固定大小的，为了对应一样，先去掉这种换算方法，直接返回固定大小
      if (zoom == 1) {
        return length
      }
      let k = 1
      if (zoom < 1) {
        k = this.$config.getFormatNumber(this.zoomfactor / (1 - this.limitZoom.out), 2)
      } else {
        k = this.$config.getFormatNumber(this.zoomfactor / (this.limitZoom.in - 1), 2)
      }
      let b = 1 - k
      let newZoom = zoom * k + b
      return this.$config.getFormatNumber(length * newZoom, 2)
    },
    setTaskImgSize (zoom) {
      this.taskImgSize.width = this.getLengthByZoom(this.taskimg.width, zoom)
      this.taskImgSize.height = this.getLengthByZoom(this.taskimg.height, zoom)
    },
    setTask (e, taskType) {
      this.curTaskType = taskType
      const { docViewer, iframeWindow } = this.instance
      const zoom = this.getZoom(docViewer)
      this.setTaskImgSize(zoom)
      const mouseLocation = this.getMouseLocation(e, docViewer)
      const windowCoordinates = { x: mouseLocation.x - this.taskImgSize.width / 2, y: mouseLocation.y - this.taskImgSize.height - this.taskImgSize.height / 2 }
      const clickedPage = this.getCurrentPage(windowCoordinates, docViewer)
      const displayMode = docViewer.getDisplayModeManager().getDisplayMode()
      let pageCoordinates = displayMode.windowToPage(windowCoordinates, clickedPage)
      const rotatedCoordinates = this.getRotatedCoordinates(pageCoordinates)
      if (!this.layer) {
        let taskImgDiv = this.createInstanceDiv(
          'layer',
          // this.getTaskImgDivCssText(pageCoordinates.y * zoom - this.taskImgSize.height / 2, pageCoordinates.x * zoom - this.taskImgSize.width)
          this.getTaskImgDivCssText(rotatedCoordinates.y * zoom, rotatedCoordinates.x * zoom)
        )
        let taskImg = this.createInstanceImg(
          this.getTaskImgSrcByTaskType(taskType),
          this.taskImgSize.width,
          this.taskImgSize.height,
          'image'
        )
        taskImgDiv.appendChild(taskImg)
        this.layer = taskImgDiv
      } else {
        this.layer.children[0].src = this.getTaskImgSrcByTaskType(taskType)
        this.layer.style.top = rotatedCoordinates.y * zoom + 'px'
        this.layer.style.left = rotatedCoordinates.x * zoom + 'px'
        this.layer.style.display = ''
      }
      const pageContainer = iframeWindow.document.getElementById('pageContainer' + clickedPage)
      pageContainer.appendChild(this.layer)
      if (!pageContainer.classList.contains('task-droppable')) {
        pageContainer.classList.add('task-droppable')
      }
      const documentContainerDiv = this.getInstanceDocumentContainerDiv()
      documentContainerDiv.addEventListener('mousemove', this.parallax, { capture: true })
      documentContainerDiv.addEventListener('mousedown', this.parallaxdown, { capture: true })
    },
    fitPage () {
      if (this.instance) {
        const model = this.instance.UI.getFitMode()
        if (model !== 'FitPage') {
          var FitMode = this.instance.UI.FitMode
          this.instance.UI.setFitMode(FitMode.FitPage)
        }
      }
    },
    zoom (type, isMouse) {
      if (this.instance) {
        const { documentViewer } = this.instance.Core
        let changeZoom = 1
        switch (type) {
          case 0:
            changeZoom = documentViewer.getZoomLevel() - 0.1
            if (changeZoom < this.limitZoom.out) {
              return
            }
            break
          case 1:
            changeZoom = documentViewer.getZoomLevel() + 0.1
            if (changeZoom > this.limitZoom.in) {
              return
            }
            break
          default:
            break
        }
        isMouse = isMouse || false
        if (isMouse) {
          documentViewer.zoomToMouse(changeZoom, 0, 0)
        } else {
          documentViewer.zoomTo(changeZoom)
        }
        this.addMarker(this)
      }
    },
    UndoOrRedo (isRedo) {
      const { documentViewer } = this.instance.Core;
      let manage = documentViewer.getAnnotationHistoryManager()
      if (isRedo) {
        manage.redo()
      } else {
        manage.undo()
      }
    },
    composeReportCommand (type) {
      return {
        type: type
      }
    },
    toAddDragMarker (command) {
      let dragType = this.getDragTypeByTaskCommand(command)
      this.addTask(window.event, dragType)
    },
    async handleReportCommand (commmand) {
      let msgType = ''
      let taskType = 0
      switch (commmand.type) {
        case 5:
          msgType = this.$t('model.Task')
          taskType = 0
          break
        case 1:
          msgType = this.$t('model.ProductInstallation')
          taskType = 1
          break
        case 4:
          msgType = this.$t('model.Moisture')
          taskType = 2
          break
      }
      let hasTasks = await this.hasTasksByPlanId(taskType)
      if (hasTasks === true) {
        this.openNewReport(commmand.type)
      }
      else {
        Notification.closeAll()
        Notification({
          title: this.$t('api.WARNING'),
          message: this.$t('model.PleaseCreate', [msgType]),
          duration: 3000,
          showClose: false,
          customClass: 'customNotify'
        })
      }
    },
    openNewReport (type) {
      this.newReportDialog.show = true
      this.newReportDialog.type = type
      this.newReportDialog.planId = this.plan.PlanId
    },
    handleNewReportDialog () {
      this.newReportDialog.show = false
      this.newReportDialog.type = 1
      this.newReportDialog.planId = null
    },
    async hasTasksByPlanId (taskType) {
      let hasTask = false
      await hasTasksByPlanId(this.plan.PlanId, taskType).then(res => {
        hasTask = true
      }).catch(err => {
        console.log(err)
        hasTask = false
      })
      return hasTask
    },
    getDragTypeByTaskCommand (command) {
      let dragType = ''
      switch (command) {
        case 'Task':
          dragType = this.TaskType.Task
          break
        case 'Product':
          dragType = this.TaskType.Product
          break
        case 'Moisture':
          dragType = this.TaskType.Moisture
          break
        case 'TaskTemplate':
          dragType = this.TaskType.TaskTemplate
          break
        default:
          break
      }
      return dragType
    },
    getIntTypeByTaskType (taskType) {
      let type = 0
      switch (taskType) {
        case this.TaskType.Task:
          type = 0
          break
        case this.TaskType.Product:
          type = 1
          break
        case this.TaskType.Moisture:
          type = 2
          break
        case this.TaskType.TaskTemplate:
          type = 3
          break
        default:
          break
      }
      return type
    },
    addDragMarker (taskType, e) {
      let type = this.getIntTypeByTaskType(taskType)

      const { docViewer } = this.instance
      const { documentViewer } = this.instance.Core
      // const zoom = this.getZoom(docViewer)
      // test
      const displayMode = docViewer.getDisplayModeManager().getDisplayMode()
      const windowCoordinates = this.getMouseLocation(e, docViewer)
      // const windowCoordinates = this.getRotatedTaskWindowCoordinates(mouseLocation)
      const clickedPage = this.getCurrentPage(windowCoordinates, docViewer)
      const pageCoordinates = displayMode.windowToPage(windowCoordinates, clickedPage)
      const doc = documentViewer.getDocument()
      // const point = this.instance.Core.Annotations.RotationUtils.getRotatedPointsArray([pageCoordinates], 180)
      const pdfCoords = doc.getPDFCoordinates(clickedPage, pageCoordinates.x, pageCoordinates.y)
      let obj = {
        product: null,
        room: null,
        point: {
          x: pdfCoords.x,
          y: pdfCoords.y
        },
        spacing: 90,
        rotation: this.pageInfo.rotation
      }
      this.$store.commit('diag/setAddTaskPointList', obj)
      this.$store.commit('diag/setAddTaskType', type)
      this.$store.commit('diag/openAddTaskDialog', true)
    },
    dataURItoBlob (dataURI) {
      // base64 解码
      let byteString = window.atob(dataURI.split(',')[1])
      let mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split('')[0]
      let ab = new ArrayBuffer(byteString.length)
      let ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    openRenameDialog () {
      this.renameDialog.showDialog = true
    },
    closeRenameDialog (val) {
      this.renameDialog.showDialog = false
      if (val.PlanId) {
        this.plan.Name = val.Name
        this.$store.commit('setPlan', this.plan)
      }
    },
    back () {
      this.isBack = true
      this.$store.commit('diag/clearTaskList')
      this.$store.commit('diag/clearTaskSortby')
      this.$store.commit('diag/setSelectPoint', {})
      this.$router.push({
        name: 'diagrams',
        params: {
          projectId: this.jobsiteID
        },
        query: {
          r: 1
        }
      })
    },
    getAnnotationToolStyle () {
      this.toolColor = this.toolStyle.color
      this.strokeThicknessInfo.strokeThickness = this.toolStyle.strokeThickness
      this.strokeThicknessInfo.highlightStrokeThickness = this.toolStyle.highlightStrokeThickness
      this.fontInfo.fontSize = this.toolStyle.fontSize
    },
    setAnnotationToolStyle () {
      const newStyle = {
        color: this.toolColor,
        strokeThickness: this.strokeThicknessInfo.strokeThickness,
        highlightStrokeThickness: this.strokeThicknessInfo.highlightStrokeThickness,
        fontSize: this.fontInfo.fontSize
      }
      this.$store.commit('diag/setPdfToolStyle', newStyle)
    },
    getNonM2ProductList () {
      let that = this
      let nonM2ProductCondition = {
        SKU: null,
        JobsiteId: that.jobsiteID,
        PageIndex: 1,
        PageSize: 10000,
        GetRecycle: false,
        OrderBy: 'LastUpdatedOn desc'
      }
      getProductList(nonM2ProductCondition).then(res => {
        that.nonM2ProductList = res.Data
      })
    },
    removeMarker (that) {
      if (!that.markerList || that.markerList.length == 0) {
        return
      }
      that.markerList.forEach(annotation => {
        annotation.Locked = false
        annotation.setCustomData('isDeleteTask', '1')
      })
      that.instance.annotManager.deleteAnnotations(that.markerList)
      that.markerList = []
    },
    createTaskImgAnnotation (img, pointX, pointY, taskId, afterCreateAnnotation) {
      const { Annotations, annotManager, docViewer } = this.instance
      const { documentViewer } = this.instance.Core
      const stampAnnot = new Annotations.StampAnnotation()
      let page = documentViewer.getCurrentPage()
      stampAnnot.PageNumber = page
      const rotation = documentViewer.getCompleteRotation(page) * 90
      stampAnnot.Rotation = rotation
      const zoom = this.getZoom(docViewer)
      if (this.taskImgSize.width == 0) {
        this.setTaskImgSize(zoom)
      }
      // const windowCoordinates = { x: pointX - this.taskImgSize.width / 2, y: pointY - this.taskImgSize.height }
      // const clickedPage = this.getCurrentPage(windowCoordinates, docViewer)
      // const pageCoordinates = this.displayMode.windowToPage(windowCoordinates, clickedPage)
      const doc = documentViewer.getDocument()
      let viewerCoords = doc.getViewerCoordinates(page, pointX, pointY)
      viewerCoords = this.getRotatedTaskViewCoordinates(viewerCoords, zoom)
      stampAnnot.X = viewerCoords.x
      stampAnnot.Y = viewerCoords.y
      stampAnnot.Width = this.taskImgSize.width
      stampAnnot.Height = this.taskImgSize.height

      let url = encodeURI(img)
      stampAnnot.ImageData = url
      stampAnnot.Author = annotManager.getCurrentUser()
      // stampAnnot.NoMove = true
      // stampAnnot.NoResize = true
      // stampAnnot.NoRotate = true
      stampAnnot.NoZoom = true
      stampAnnot.Locked = true
      stampAnnot.setCustomData('taskid', taskId)
      stampAnnot.setCustomData('pointX', pointX.toString())
      stampAnnot.setCustomData('pointY', pointY.toString())
      annotManager.addAnnotation(stampAnnot)
      annotManager.redrawAnnotation(stampAnnot)
      afterCreateAnnotation(stampAnnot)
    },

    async closeAddTaskDialog (id) {
      this.$store.commit('diag/openAddTaskDialog', false)
      if (this.addTaskPointList && this.addTaskPointList.length > 0) {
        const windowCoordinates = this.getCoordinates(this.addTaskPointList[0].point.x, this.addTaskPointList[0].point.y)
        this.removeTaskByWindowCoordinates(windowCoordinates)
      }
      this.$store.commit('diag/clearAddTaskPointList')
      this.$store.dispatch('getTaskGroup')
      if (id) {
        if (typeof (id) === 'string') {
          this.$router.push({
            name: 'modelTask2',
            params: {
              id: id
            }
          })
        } else {
          if (this.$router.currentRoute.name !== 'taskList2') {
            this.$router.push({
              name: 'taskList2'
            })
          }
        }
        this.$store.dispatch('diag/getTasksList')
        await this.getNonM2ProductList()
        // let that = this
        // that.createTaskImgAnnotation(that.img.taskSelect, that.selectPoint.x, that.selectPoint.y, id, function (createdAnnotation) {
        //   that.selectAnnotation = createdAnnotation
        //   that.markerList.push(createdAnnotation)
        // })
      }
    }
  },
  beforeDestroy () {
    if (this.$refs.pdftron) {
      this.$refs.pdftron.closeLoading()
    }
  },
  destroyed () {
    if (this.annotationsLoaded) {
      if (this.instance.iframeWindow) {
        this.instance.iframeWindow.removeEventListener('popstate', this.iframeWindowgoBack, false)
      }
      window.removeEventListener('popstate', this.windowgoBack, false)
    }
  }
}
</script>

<style lang="scss">
.view {
  width: 100%;
  .el-checkbox {
    display: block !important;
    width: 100%;
    height: 30px;
    line-height: 30px;
    .el-checkbox__input {
      display: none;
    }
    &.is-checked {
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 20px;
        width: 20px;
        background-image: url("../../../assets/image/check.png");
        color: #4193f6;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .el-radio {
    display: block !important;
    width: 100%;
    height: 30px;
    line-height: 30px;
    .el-radio__input {
      display: none;
    }
    &.is-checked {
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 20px;
        width: 20px;
        background-image: url("../../../assets/image/check.png");
        color: #4193f6;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
.clear {
  position: absolute;
  right: 5px;
  top: 5px;
}
.customNotify {
  .el-notification__content {
    text-align: left;
  }
}
.toolBar {
  z-index: 25;
  left: 20px;
  top: 50%;
  position: fixed;
  margin-top: -225px;
  cursor: grab;
  .toolBar-container {
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    background-color: #4c4c4c;
    width: auto;
    padding: 0.25rem;
    .toolBarItem {
      height: 40px;
      background-color: #686363;
      margin-top: 4px;
      border-radius: 30px;
      .toolDiv {
        display: inline-block;
        width: 22px;
        height: 22px;
        overflow: hidden;
        .toolI {
          position: relative;
          left: -22px;
          filter: drop-shadow(#abb0c4 22px 0px);
          img {
            height: 22px;
          }
        }
      }
    }
  }
}
.el-color-dropdown__main-wrapper {
  display: none;
}
.el-color-dropdown {
  background-color: #686363;
}
.el-color-dropdown__btns {
  .el-color-dropdown__value {
    display: none;
  }
  .el-color-dropdown__link-btn {
    display: none;
  }
}
.toolButton {
  padding: 0;
  border: none;
  background-color: transparent;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  width: 40px;
  height: 40px;
}
.toolDivActive {
  button {
    border: 2px solid white;
    border-radius: 30px;
    filter: brightness(100);
  }
}

.toolButton:hover {
  border: 2px solid white;
  border-radius: 30px;
  filter: brightness(100);
}

.Icon {
  width: 22px;
  height: 22px;
  pointer-events: none;
  color: #868e96;
}
</style>
<style scoped lang='scss'>
.wrapper {
  position: relative;
  width: 100%;
  flex-direction: row;
  .left {
    height: 100%;
    flex-grow: 1;
    .header {
      height: 38px;
      overflow: hidden;
      padding: 0 8px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dcdfe6;
      justify-content: space-between;
      .el-button {
        font-size: 20px;
      }
      .title {
        display: flex;
        flex: 1;
        width: 0;
        .name {
          padding-left: 8px;
          font-size: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .option-line {
        max-width: 360px;
        z-index: 1000;
        display: flex;
        align-items: center;
        /deep/.el-button {
          margin-right: 8px;
          margin-left: 8px;
          font-size: 24px;
        }
        margin-left: 24px;
      }
    }
    .main {
      height: calc(100% - 38px);
      .diag {
        width: 100%;
        height: 100%;
        position: relative;
        .add-task {
          position: absolute;
          right: 20px;
          top: 10px;
          z-index: 1000;
        }
        .container {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 15;
          margin: 0 auto;
          canvas {
            z-index: 10;
            width: 100%;
            height: 100%;
            position: absolute;
            // left: 50%;
            // top: 50%;
            // transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
  .right {
    width: 450px;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #dcdfe6;
    .router-box {
      flex-grow: 2;
      height: 0;
    }
    .el-menu {
      display: flex;
      li {
        flex-grow: 1;
        padding: 0;
        text-align: center;
        height: 39px;
        line-height: 38px;
        font-size: 16px;
        .menu-icon {
          margin-right: 10px;
        }
      }
    }
  }
}
.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
/deep/.el-badge__content.is-fixed.is-dot {
  bottom: 6px;
  top: auto;
  right: 21px;
}
</style>
